import { newrelic } from "@jti/fe-clients";

export const sanitizeBaseUrl = (baseUrl: string) => {
  if (typeof baseUrl !== "string") {
    const message = "sanitizeBaseUrl: baseUrl is not a string, returning empty string instead.";
    console.warn(message);
    newrelic.noticeError(new Error(message));
    return "";
  }

  return baseUrl.endsWith("/api") ? baseUrl.slice(0, -4) : baseUrl;
};
